import customTheme from "../../../theme";
import {
	columnsWidth,
	columnsCount,
	gutterWidths,
	marginWidths,
} from "../../constants/Login";

/** Estilos provisionales en HomePage */
const homePageStyles = {
	root: {
		height: "100vh",
		backgroundColor: customTheme.paleta.gris96,
		overflow: "auto",
		color: "#47495c",
		display: "flex",
	},
	main: {
		flexGrow: 1,
		padding: customTheme.spacing(4),
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
		position: "relative",
	},

	mainPlusSidebar: {
		width: '100%',
		display: 'flex',
	},

	imageContainer: {
		zIndex: customTheme.zIndex.drawer + 1,
		[customTheme.breakpoints.only("sm")]: {
			display: "none",
		},
		[customTheme.breakpoints.only("xs")]: {
			display: "none",
		},
		marginTop: "auto",
		position: "fixed",
		bottom: customTheme.spacing(1),
		paddingLeft: customTheme.spacing(1),
		[customTheme.breakpoints.only("md")]: {
			width: `calc((((100% - ${columnsWidth.md}px) * 6) / ${columnsCount.md
				}) + ${gutterWidths.md * 5 + marginWidths.md * 1}px)`,
		},
		[customTheme.breakpoints.only("lg")]: {
			width: `calc((((100% - ${columnsWidth.lg}px) * 6) / ${columnsCount.lg
				}) + ${gutterWidths.lg * 5 + marginWidths.lg * 1}px)`,
		},
		[customTheme.breakpoints.only("xl")]: {
			width: `calc((((100% - ${columnsWidth.lg}px) * 6) / ${columnsCount.lg
				}) + ${gutterWidths.lg * 5 + marginWidths.lg * 1}px)`,
		},
	},

	loadingSection: {
		padding: customTheme.spacing(4),
		margin: "auto",
		alignContent: "center",
		display: "table",
	},

	appBar: {
		backgroundColor: "#fff",
		color: "#373740",
		fontSize: "16px",
		fontWeight: 500,
		lineHeight: 1.5,
	},
	accountIcon: {
		color: "#373740"
	},
	accountUsername: {
		color: "#373740",
		marginLeft: "0"
	},
	logout: {
		marginTop: customTheme.spacing(0.5),
		marginLeft: customTheme.spacing(3),
		cursor: "pointer",
	},
	spacer: {
		flexGrow: 1,
	},

	breadCrumb: {
		paddingLeft: customTheme.spacing(3),
		paddingRight: customTheme.spacing(4),
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#fff",
		border: "1px solid #e5e5e5",

	},

	modal: {
		borderRadius: "5px",
		boxShadow: customTheme.shadows[5],
		padding: customTheme.spacing(4),
	},
	modalHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "flex-start",
		marginBottom: customTheme.spacing(2),
	},
	modalHeaderText: {
		fontSize: "24px",
		fontWeight: 500,
		color: "#373740",
		flex: 1,
	},
	modalTitle: {
		marginBottom: "4px",
		fontWeight: 500,
	},
	modalConfirmation: {
		paddingTop: "18px",
	},
	modalConfirmationSpan: {
		marginBottom: customTheme.spacing(2),
		marginTop: "0px",
	},
	modalButtons: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
	},
	modalActionButton: {
		marginLeft: customTheme.spacing(2),
	},

	// Sidebar styles
	sidebarContainer: {
		width: customTheme.spacing(48),
		flexShrink: 0,
	},
	phoneSx: {
		xs: "block",
		sm: "block",
		md: "none",
		lg: "none",
		xl: "none",
	},
	desktopSx: {
		xs: "none",
		sm: "none",
		md: "block",
		lg: "block",
		xl: "block",
	},
	drawer: {
		"& .MuiDrawer-paper": {
			flexShrink: 0,
			width: customTheme.spacing(48),
			backgroundColor: '#0b5c96',
		}
	},
	drawerLogo: {
		marginTop: customTheme.spacing(2),
		marginBottom: customTheme.spacing(2),
		display: 'flex',
		width: customTheme.spacing(25),
		marginLeft: customTheme.spacing(2),
		justifyContent: "center",
		alignItems: "center",
		cursor: 'pointer'
	},
	drawerImageIcon: {
		height: customTheme.spacing(4)
	},
	toolbar: customTheme.mixins.toolbar,
	menuItems: {
		color: '#ffffff',
		paddingTop: customTheme.spacing(0.25),
		paddingBottom: customTheme.spacing(0.25),
		paddingLeft: customTheme.spacing(3),
		paddingRight: customTheme.spacing(3),
		//backgroundColor: "#329be6",
		flexGrow: 1,
		display: "flex",
		flexDirection: "column",
	},
	titleSearchContainer: {
		padding: 1
	},
	iconSearch: {
		color: '#fff',
		marginRight: "16px",
	},
	titleSearch: {
		fontWeight: 500,
		fontSize: '16px'
	},
	subtitleSearch: {
		fontSize: '14px'
	},
	//Search Styles
	dividerContainer: {
		width: '100%',
		textAlign: 'center',
		borderBottom: '1px solid #fff',
		lineHeight: '0.1em',
		margin: '10px 0 10px'
	},
	divider: {
		background: '#0b5c96',//'#329be6',
		padding: '0 10px',
		fontSize: '16px',
		fontFamily: 'Roboto',
		fontWeight: 400,
		color: '#fff'
	},
	searchContainer: {
		"& .MuiFormLabel-root": {
			color: "#fff"
		},
		"& .Mui-focused": {
			color: "#2B2B2B"
		},
		flexGrow: 1,
		display: "flex",
		flexDirection: "column",
	},
	btnSearch: {
		backgroundColor: customTheme.palette.success.dark,
		"&:hover": {
			backgroundColor: customTheme.palette.success.main,
		},
	},
	btnClear: {
		border: "1px solid #fff"
	},

	pageTitle: {
		fontWeight: 500,
		marginBottom: customTheme.spacing(3),
	},
	btnContinue: {
		backgroundColor: customTheme.palette.success.main,
		"&:hover": {
			backgroundColor: customTheme.palette.success.dark,
		},
	},
	btnPrimary: {
		backgroundColor: customTheme.palette.primary.main,
		"&:hover": {
			backgroundColor: customTheme.palette.primary.dark,
		},
	},
    btnSecondary: {
		border: "1px solid #d8d8e1",
        backgroundColor: '#FFFFFF',
		fontWeight: 500,
		fontSize:14,
		fontFamily:'Roboto',
        color: '#0b5c96',
		boxShadow: "none",
        "&:hover": {
            background: "#bee2fc",
			color: '#0b5c96',
			boxShadow: "none"
        }
       
    },

	backdrop: {
		color: '#008d79',
		backgroundColor: 'rgba(255, 255, 255, 0.60)',
		left: '240px', // o lo que mida tu sidebar
		width: 'calc(100vw - 240px)',
		position: "fixed",
		zIndex: customTheme.zIndex.drawer - 150,
	},
	tabsContainer: {
		'@media (min-width:1260px) and (max-width:1350px)': {
			width: 800,
		},
		'@media (min-width:1163px) and (max-width:1260px)': {
			width: 700,
		},
	},
	// Result page
	icon: {
		fontSize: 30
	},
	cardGrid: {
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 2,
		padding: 2
	},
	stackRow: {
		width: '100%'
	},
	stackColumn: {
		flex: 1
	},
	boxMargin: {
		marginBottom: 1
	},
	typography: {
		fontWeight: 500
	},
	status: {
		active: {
			bgColor: "#e3f1df",
			textColor: "#19340c"
		},
		inactive: {
			bgColor: "#fef7e9",
			textColor: "#613400"
		}
	},
	secondaryTitle: {
		marginBottom: customTheme.spacing(3),
	},
	secondaryTitleContainer: {
		color: '#000000',
		backgroundColor: '#e1f1fd',
		alignItems: 'center',
		fontSize: '18px',
		paddingLeft: '8px'
	},
	secondaryTitleItem: {
		[customTheme.breakpoints.up('xs')]: {
			paddingBottom: 20,
			paddingRight: 4
		},
		[customTheme.breakpoints.up('md')]: {
			paddingRight: 20,
			paddingBottom: 4
		},
		[customTheme.breakpoints.up('lg')]: {
			paddingRight: 20,
			paddingBottom: 4
		},
		[customTheme.breakpoints.up('xl')]: {
			paddingRight: 20,
			paddingBottom: 4
		}
	},
	confirmUnify: { 
		width: '100%', 
		fontWeight: 'bold', 
		paddingTop: 20 
	},

	sessionsContainer: { 
		width: '100%',
		paddingTop: 4
	},
	sessionsLookup: {
		flex: 1 
	},
	sessionsDatePicker: {
		flex: 2
	},

	supportContainer: { 
		width: '100%', 
		paddingTop: 4 
	},
	supportFilters: { 
		width: '100%' 
	},
	supportLookup: {
		flex: 1 
	},
	supportDatePicker: {
		flex: 2
	},

	payrollsContainer: { 
		width: '100%',
		paddingTop: 4 
	},
	payrollsLookup: {
		flex: 1 
	},
	payrollsDatePicker: {
		flex: 2
	},
	modalEditDataValue:{
		fontSize: '16px',
		fontWeight: 'bold',
		color: '#373740',
	}
};

export default homePageStyles;
